module.exports = __webpack_public_path__ + "static/media/delete button yellow.584ff056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/delete button yellow.svg
// module id = 877
// module chunks = 0